/* eslint-disable no-unused-vars */
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { store } from "../store/index";
/**
 * @typedef {ReturnType<typeof store.getState>} StoreType
 */

/**
 * @type {TypedUseSelectorHook<StoreType>}
 */
export const useAppSelector = useSelector;
